export type PreAcceptInvitationBody = {
    invitation: string;
};

export enum TYPE_DATA_INVITATION {
    PRODUCT = 'PRODUCT',
    KUBO = 'KUBO'
}
